import _ from 'lodash';
import { config } from '../global/config';
import { formatPrice } from '../global/helpers';

interface IAmountProps {
  value?: number;
}

export const Amount = (props: Readonly<IAmountProps>) => {
  if (_.isNil(props.value)) return <></>;
  return (
    <span>
      {formatPrice(props.value).split('.')[0]}
      {formatPrice(props.value).split('.').length > 1 ? (
        <sup>{`.${formatPrice(props.value).split('.')[1]} ${
          config.currency
        }`}</sup>
      ) : (
        <sup>{` ${config.currency}`}</sup>
      )}
    </span>
  );
};
